<template>
  <a-modal :title="title" :width="1000" :visible="visible" :confirmLoading="confirmLoading" switchFullscreen
    @ok="handleOk" @cancel="handleCancel" cancelText="关闭">
    <a-form-model layout="horizontal" :model="model" v-bind="{ labelCol: { span: 6 }, wrapperCol: { span: 14 }, }"
      ref="ruleForm" :rules="rules">
      <a-form-model-item prop="newFormName" label="问卷表单名称">
        <a-input placeholder="请输入问卷表单名称" v-model="model.newFormName" allowClear/>
      </a-form-model-item>
    </a-form-model>
  </a-modal>
</template>

<script>
import baseRules from '@/constants/baseRules'
import { getAction, postAction } from '@/api/manage'
export default {
  name: "CsimSchemaCopyFormModal",
  props: {
    mergeForms: {
      type: Array,
      required: false
    }
  },
  data() {
    return {
      title: "操作",
      visible: false,
      confirmLoading: false,
      sexList: [
        { text: '女', value: '0' },
        { text: '男', value: '1' },
        { text: '均可', value: '2' },
      ],
      testList: [
        { text: '自评', value: '0' },
        { text: '他评', value: '1' },
        { text: '均可', value: '2' },
      ],
      rules: {
        name: [baseRules.required],
        //name_en: [baseRules.required],
        code: [baseRules.required],
        useTime: [baseRules.required],
        scale: [baseRules.requiredChange],
        keywordList: [baseRules.requiredChange],
      },
      model: {}
    }
  },  

  methods: {
    keywordChange() {
      this.$set(this.model, 'keyword', this.model.keywordList.join(','))
    },
    filterOption(input, option) {
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
    },
    dummyValidator(rule, value, callback) {
      callback();
    },
    checkFormData() {
      let isValid = false
      this.$refs.ruleForm.validate(valid => {
        isValid = valid
      })
      return isValid
    },
    handleOk() {
      console.log("handleOk: ", this.model);

      if (this.mergeForms.length != 1) {
        this.$message.error("请选择一个表单进行复制");
        return;
      }

      this.model.formId = this.mergeForms[0].id;

      postAction('/scheme/form/copy', this.model).then(res=>{
        if(res.success){
          this.$message.success(res.message)
          this.handleCancel();
          this.$emit("clearSelectedForms");
        } else {
          this.$message.error(res.message)
        }
      }).finally(()=>{
        // todo
        this.$emit("refreshFormList");
      })
    },
    handleCancel() {
      this.visible = false;
    },
  }
}
</script>

<style lang="less" scoped></style>